import { loadStripe } from '@stripe/stripe-js';

function stripePublishableKey(): string {
	if (window.location.hostname === 'localhost')
		return 'pk_test_51Md2TwGXx5zGfXo8WLrYJP0wInTYp2n6fku5DyA79dxxOaLtwKgQPoElhX064Eb6KXyIXBIR54LOXe69fA055TwU00elugagSS';
	return 'pk_live_51Md2TwGXx5zGfXo8G9O4zdsQXflDXk4qgOtWhhx3Gl9tAciaMcOENEjzxI5sB4J0FR6GJMjRhKyTdJbWVMKaimod003mjpW7T6';
}

export const stripePromise = loadStripe(stripePublishableKey());
